import supportConfig from './feature/support'

export const floatingChatConfig = {
  ROUTE_BLACKLIST: supportConfig.chat.floatingButton.hiddenPaths,
}

export const chatConfig = {
  EVENT_LABEL: supportConfig.chat.event.label,
  COMMUNITY_ROUTE: supportConfig.chat.community.route,
}
